export const ExpressCheckoutAbTest = {
  TEST_ID: 'LixCqDh-QF-7qH7FKmJYDQ',
  name: 'Express Checkout AB Test - November 2021',
};

export const AccountCrossSellBannerCtaDestinationExperiment = {
  TEST_ID: '5l9j4H1vQpK1H_6veuHyqw',
  name: 'SK | Account Cross Sell Banner CTA Destination - June 2023',
};

export const GrowthbookFakeExperimentExperiment = {
  TEST_ID: 'oHUXOZBgQHy7KCSh97Wjbg',
  name: 'GrowthBook Fake Experiment',
};

export const HowItWorksVideoConsultationExperiment = {
  TEST_ID: 'Eje2CHEL%5XJnf2N',
  name: 'How It Works Video C1HC - Feb 2024',
};
export const ShipNowExperiment = {
  TEST_ID: '69f993F50d20cd09C98198',
  name: 'Ship Now Launch AB test - February 2024',
};
export const EmailNameConsultationCaptureExperiment = {
  TEST_ID: '9b872cd7ac045f9ac3f066bec4a4729a',
  name: 'Name/Email Capture in HC Consultation - February 2024',
};
export const GrowthbookFakeAaTestExperiment = {
  TEST_ID: '6a9c488c282bfbc11ef95afb0fdc2c0f',
  name: 'Growthbook AA test experiment',
};
export const HomepageRevampExperiment = {
  TEST_ID: 'dad9286568933582f3c70df024d67cd08a4d8b91e2252913a818b2d0ad346bf9',
  name: 'homepage-revamp-abcdtest',
};
